import {TweenLite, TimelineLite} from "gsap";
import {TheCryptHelper} from "../utils/TheCryptHelper";
import {TheCrypt} from "../TheCrypt";
import {TheCryptSoundManager} from "../sound/TheCryptSoundManager";
import {TheCryptSoundConfig} from "../configs/TheCryptSoundConfig";
import Spine = PIXI.spine.Spine;
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";

export class ExtraFreespinAwardView extends PIXI.Container {
    private _spine: Spine | null;

    constructor() {
        super();
        this.name = "ExtraFreespinAwardView";
        this.init();
    }

    private init() {
        this.position.set(360, 360);
        this.visible = false;
    }

    public reset(): void {
        if (this._spine) {
            this._spine.destroy();
            this._spine = null;
        }
        this.visible = false;
    }

    public show(): TimelineLite {
        this.position.set(360, 360);
        if (this._spine) {
            this._spine.destroy();
            this._spine = null;
        }
        if (!Number.isInteger(TheCrypt.model.sideBarProgress[0] / 4)) {
            debugger
            throw Error;
        }
        this._spine = new PIXI.spine.Spine(TheCrypt.assetLoader.getSpineAsset("plus2banner"));
        this._spine!.skeleton.setSkinByName(`M${6-TheCrypt.model.gameData.dragonSideReel[0] / 4+1}`);
        const tl: TimelineLite = new TimelineLite();
        tl.add([
            () => {
                this.visible = true;
                this.addChild(this._spine!);
                TheCryptSoundManager.playSound(TheCryptSoundConfig.FREESPINS_ADD_2);
            },
            new SpineTween(this._spine, 0, "base"),
            TweenLite.to(this, 1.5, {alpha:1})
        ]);
        tl.add(() => {
            TheCrypt.keypadPlugin.setZeroBetSpinCounter(TheCrypt.model.freespinsLeft);
        },'-=0.5');
        tl.add(() => {
            if (this._spine) {
                this._spine.destroy();
                this._spine = null;
            }
            this.visible = false;
        });
        return tl;
    }
}